<div class="summary-transfer-content">
  <div class="summary-transfer-content__summary-container">
    <div class="summary-transfer-content__summary-sections">
      <div class="summary-transfer-content__section">

        <h3 class="summary-transfer-content__section-heading">
          {{ 'contribute.step.summary' | translateLang }}
        </h3>

        <!-- Destination Fund Number -->
        <div class="summary-transfer-row summary-transfer-row--fund-number">
          <span class="summary-transfer-row__label">{{ 'transfer.summary.destination_number' | translateLang }}</span>
          <span class="summary-transfer-row__value">
            {{ displayData.receiverFundNumber }}
          </span>
        </div>

        <!-- Destination Fund Name -->
        @if (displayData.receiverFundName) {
          <div class="summary-transfer-row summary-transfer-row--fund-name">
            <span class="summary-transfer-row__label">{{ 'transfer.summary.destination_name' | translateLang }}</span>
            <span class="summary-transfer-row__value">
              {{ displayData.receiverFundName }}
            </span>
          </div>
        }

        <!-- Amount -->
        <div class="summary-transfer-row">
          <span class="summary-transfer-row__label">{{ 'transfer.summary.amount' | translateLang }}</span>
          <span class="summary-transfer-row__value summary-transfer-row__value--bold">
            {{ formatNumberValue(displayData.amount) }} {{ currency }}
          </span>
        </div>

        <!-- Timing -->
        <div class="summary-transfer-row">
          <span class="summary-transfer-row__label">{{ 'grant.form.timing.label' | translateLang }}</span>
          <span class="summary-transfer-row__value">
            {{
              displayData.timing === 'As soon as possible'
                ? ('grant.form.timing.asap' | translateLang)
                : formatDateValue(displayData.timing)
            }}
          </span>
        </div>

        <!-- Additional Notes -->
        @if (displayData.additionalNotes) {
          <div class="summary-transfer-row">
            <span class="summary-transfer-row__label">{{ 'transfer.summary.special_instructions' | translateLang }}</span>
            <span class="summary-transfer-row__value">{{ displayData.additionalNotes }}</span>
          </div>
        }

      </div>
    </div>
  </div>
</div>
